/* eslint-disable */
const fallbackPrintByUsb = async (content) => {
    try {
        const device = await getConnectedUSBDevice();
        if (!device) return false;

        if (!device.opened) {
            await device.open();
        }

        const availableEndpoints = [];
        device.configuration.interfaces.forEach((iface) => {
            iface.alternates.forEach((alt) => {
                alt.endpoints.forEach((ep) => {
                    availableEndpoints.push(ep.endpointNumber);
                });
            });
        });

        await device.selectConfiguration(1);
        await device.claimInterface(0);
        await device.selectAlternateInterface(0, 0);

        const encoder = new TextEncoder();
        const data = encoder.encode(content);
        availableEndpoints.sort((a, b) => a - b);

        for (const endpoint of availableEndpoints) {
            try {
                await device.transferOut(endpoint, data);
                break;
            } catch (error) {
                console.error("Error al imprimir en endpoint", endpoint, error);
            }
        }

        await device.close();
        return true;
    } catch (error) {
        console.error("Error en fallback de impresión WebUSB:", error);
        return false;
    }
};

const getConnectedUSBDevice = async () => {
    try {
        const devices = await navigator.usb.getDevices();
        return devices.length > 0 ? devices[0] : await requestDevice();
    } catch (error) {
        console.error("Error al obtener dispositivos USB:", error);
        return await requestDevice();
    }
};

const requestDevice = async () => {
    try {
        return await navigator.usb.requestDevice({
            filters: [{ classCode: 7 }] // Clase para impresoras
        });
    } catch (error) {
        console.error("Error al solicitar dispositivo USB:", error);
        return null;
    }
};

const printByUsb = async (content, printerName) => {
    const EXTENSION_ID = "idkpcgloigdlkbbpagmhiimddfhgbmml";

    if (window.chrome?.runtime?.sendMessage) {
    return new Promise((resolve, reject) => {
        if (!window.chrome || !window.chrome.runtime) {
            return reject(new Error("La extensión no está disponible"));
        }

        chrome.runtime.sendMessage(
            EXTENSION_ID,
            { type: "usb", content, printerName },
            (response) => {
                if (chrome.runtime.lastError) {
                    return reject(new Error(chrome.runtime.lastError.message));
                }

                if (!response || response.status !== "ok") {
                    const errorMessage = response?.message || "Error desconocido al imprimir";
                    return reject(new Error(errorMessage));
                }

                resolve(true);
            }
        );
    });
    } else {
        console.warn("Extensión no detectada, usando WebUSB...");
        return await fallbackPrintByUsb(content);
    }
};

export { printByUsb };
